import backofficeService from "@/api/backoffice.js";

const api = backofficeService.Api;

export default {
  getAll(params) { return api().get("virtualclassroom", { params }).then((response) => response.data); },
  create(data) { return api().post("virtualclassroom", data).then((response) => response.data); },
  update(id, data) { return api().put(`virtualclassroom/${id}`, data).then((response) => response.data); },
  setCurriculums(id, data) { return api().post(`virtualclassroom/${id}/curriculums`, data).then((response) => response.data); },
  generateClassroomReportCard(data) { return api().post("virtualclassroom/report-card/generate", data).then((response) => response.data); },
  delete(id) { return api().delete(`virtualclassroom/${id}`).then((response) => response.data); },
  getStudents(params) { return api().get("virtualclassroomstudent", { params }).then((response) => response.data); },
  assignStudent(data) { return api().post("virtualclassroomstudent", data).then((response) => response.data); },
  removeStudent(id) { return api().delete(`virtualclassroomstudent/${id}`).then((response) => response.data); },
};
